<template>
  <div class="info-text">
    <p v-for="keyValue in keyValues" :key="keyValue.title" class="infoHeaderText">
      {{ keyValue.title }}: {{ keyValue.value }}
    </p>
    <p class="infoText">
      {{ infoText }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'OverlayProductInfoBox',
  props: {
    keyValues: {
      type: Array,
      default: () => []
    },
    infoText: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
@use '@/design-system/design-tokens/mixins.scss';

.info-text {
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 5px;
  @include mixins.scrollbar-vertical;
}
.infoText {
  font-weight: bolder;
}
.infoHeaderText {
  font-weight: bolder;
}
</style>
